module.exports = __webpack_public_path__ + "static/media/heart18.f4cd2506.svg";